/**
 * `/rooms` layout (lane BOO1): one room list for `/rooms` and every `/rooms/$roomId`, so moving between rooms keeps
 * the list mounted (its search, scroll and live stream) and only the room pane changes. Below 768 px the list is the
 * page on `/rooms` and gives way to the room on `/rooms/$roomId`; from 768 px it stays beside the pane. Signed out or
 * while the session loads, the child page says so on its own (each in its own words).
 */
import { Outlet, createFileRoute, useParams } from '@tanstack/react-router'
import { cx } from '@algoboo/ui'
import { useSession } from '../components/session'
import { RoomList } from '../components/rooms/RoomList'
import { PushPrompt } from '../components/rooms/PushPrompt'
import { discoverRoomsQuery, myRoomsQuery } from '../lib/api/rooms'
import { prefetchSignedIn } from '../lib/route-data'

export const Route = createFileRoute('/rooms')({
  loader: ({ context: { queryClient: qc } }) => prefetchSignedIn(qc, () => [qc.ensureInfiniteQueryData(myRoomsQuery('')), qc.ensureQueryData(discoverRoomsQuery(''))]),
  component: RoomsLayout,
})

function RoomsLayout() {
  const { me } = useSession()
  const roomId = useParams({ strict: false }).roomId ?? null
  if (!me) return <Outlet />
  return (
    <div className="grid h-full min-h-0 md:grid-cols-[minmax(300px,380px)_1fr]">
      <div className={cx('min-h-0 flex-col', roomId ? 'hidden border-r border-line md:flex' : 'flex md:border-r md:border-line')}>
        {!roomId && (
          <div className="px-3 pt-3 empty:hidden sm:px-4">
            <PushPrompt />
          </div>
        )}
        <div className="min-h-0 flex-1">
          <RoomList activeId={roomId} meUserId={me.user.id} />
        </div>
      </div>
      <Outlet />
    </div>
  )
}
